import { createFeatureSelector, createSelector } from '@ngrx/store';
import { PropertyState } from '../reducers/propertypane.reducer';

export const propertiesState: any = createFeatureSelector<PropertyState>('properties');

export const propertiesBasicData = createSelector(propertiesState, (state: any) => {
  return state.propertiesData?.properties;
});

export const propertiesData = createSelector(propertiesState, (state: any) => {
  return state.propertiesData?.properties;
});

export const currentClickedNode = createSelector(propertiesState, (state: any) => {
  return state.propertiesData;
});

export const allPropertiesData = createSelector(propertiesState, (state: any) => {
  return state.allProperties;
});

export const propertiesValues = createSelector(propertiesState, (state: any) => {
  return state.propertiesValues;
});

export const screenPropertiesValues = createSelector(propertiesState, (state: any) => {
  return { ...state.propertiesValues, ...{ currentScreenId: state.currentScreenId } };
});

export const propertiesType = createSelector(propertiesState, (state: any) => {
  return state.propertiesType;
});
export const clearLookUp = createSelector(propertiesState, (state: any) => {
  return state.clear;
});
export const picklist = createSelector(propertiesState, (state: any) => {
  return state.picklist;
});

export const lookupFields = createSelector(propertiesState, (state: any) => {
  return state.lookupFields;
});

export const mandatoryFilters = createSelector(propertiesState, (state: any) => {
  return state.mandatoryFilters;
});

export const parentNodeType = createSelector(propertiesState, (state: any) => {
  return state.parentNodeType;
});

export const tabMapFlds = createSelector(propertiesState, (state: any) => {
  return state.tabMapFlds;
});

export const funcPKflds = createSelector(propertiesState, (state: any) => {
  return state.funcPKflds;
});

export const selLkTbl = createSelector(propertiesState, (state: any) => {
  return state.selLkTbl;
});

export const mfTblFlds = createSelector(propertiesState, (state: any) => {
  return state.mfTblFlds;
});

export const screenValues = createSelector(propertiesState, (state: any) => {
  return state.screenValues;
});

export const propLoading = createSelector(propertiesState, (state: any) => {
  return state.triggerPropLoading;
});

export const tableNames = createSelector(propertiesState, (state: any) => {
  return state.tableNames;
});

export const curNodeData = createSelector(propertiesState, (state: any) => {
  return state.curNodeData;
});

export const searchFields = createSelector(propertiesState, (state: any) => {
  return state.searchFields;
});
